import React, { FC } from "react";
import { Avatar as MuiAvatar, AvatarProps } from "@mui/material";

const Avatar: FC<AvatarProps> = (props) => <MuiAvatar {...props} />;

export default Avatar;
